// Production console guard — silences console.log/info/debug in production
// builds so the client console stays clean. console.warn/error are preserved
// (errors are also forwarded to the backend via clientErrorReporter).
// In development everything stays visible.
export function installConsoleGuard() {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined' || window.__voxConsoleGuard) return;
  window.__voxConsoleGuard = true;

  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.trace = noop;
}
